import { useApiDefaults } from './useApiDefaults';
import { useQuery } from '@tanstack/react-query';
import axios from 'config/axios';
import { ReactQueryKeys } from 'config/constant';

export function useGetProductsFromUpc({ upcs }, enabled = true) {
  const apiDefaults = useApiDefaults();
  
  const body = {
    ...apiDefaults,
    input_upcs: upcs || []
  };

  const getProductsFromUpc = async () => {
    if (!upcs || upcs.length === 0) {
      return [];
    }
    
    const response = await axios.post("/AogGetProductsUPCWise", body);
    return response?.data?.data || [];
  };

  const {
    data: products = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: [ReactQueryKeys.PRODUCTS_FROM_UPC, upcs, apiDefaults],
    queryFn: getProductsFromUpc,
    enabled,
  });

  return {
    products,
    isLoading,
    error,
  };
}